module.exports = __webpack_public_path__ + "static/media/lumenlife-5.f00eaad0.jpg";